export default __webpack_public_path__ + "static/media/project_ob_on.a290dbea.svg";